"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_SEPARATORS = void 0;
/* @generated */
// prettier-ignore
exports.TIME_SEPARATORS = {
    "default": ":",
    "localeData": {
        "aa": {
            "nu": [
                "latn"
            ]
        },
        "aa-DJ": {
            "nu": [
                "latn"
            ]
        },
        "aa-ER": {
            "nu": [
                "latn"
            ]
        },
        "ab": {
            "nu": [
                "latn"
            ]
        },
        "af": {
            "nu": [
                "latn"
            ]
        },
        "af-NA": {
            "nu": [
                "latn"
            ]
        },
        "agq": {
            "nu": [
                "latn"
            ]
        },
        "ak": {
            "nu": [
                "latn"
            ]
        },
        "am": {
            "nu": [
                "latn"
            ]
        },
        "an": {
            "nu": [
                "latn"
            ]
        },
        "ann": {
            "nu": [
                "latn"
            ]
        },
        "apc": {
            "nu": [
                "latn"
            ]
        },
        "ar": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-AE": {
            "nu": [
                "latn",
                "latn"
            ]
        },
        "ar-BH": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-DJ": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-DZ": {
            "nu": [
                "latn",
                "latn"
            ]
        },
        "ar-EG": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-EH": {
            "nu": [
                "latn",
                "latn"
            ]
        },
        "ar-ER": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-IL": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-IQ": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-JO": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-KM": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-KW": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-LB": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-LY": {
            "nu": [
                "latn",
                "latn"
            ]
        },
        "ar-MA": {
            "nu": [
                "latn",
                "latn"
            ]
        },
        "ar-MR": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-OM": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-PS": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-QA": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-SA": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-SD": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-SO": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-SS": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-SY": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-TD": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "ar-TN": {
            "nu": [
                "latn",
                "latn"
            ]
        },
        "ar-YE": {
            "nu": [
                "arab",
                "latn"
            ]
        },
        "arn": {
            "nu": [
                "latn"
            ]
        },
        "as": {
            "nu": [
                "beng"
            ]
        },
        "asa": {
            "nu": [
                "latn"
            ]
        },
        "ast": {
            "nu": [
                "latn"
            ]
        },
        "az": {
            "nu": [
                "latn"
            ]
        },
        "az-Arab": {
            "nu": [
                "arabext"
            ]
        },
        "az-Arab-IQ": {
            "nu": [
                "arabext"
            ]
        },
        "az-Arab-TR": {
            "nu": [
                "arabext"
            ]
        },
        "az-Cyrl": {
            "nu": [
                "latn"
            ]
        },
        "az-Latn": {
            "nu": [
                "latn"
            ]
        },
        "ba": {
            "nu": [
                "latn"
            ]
        },
        "bal": {
            "nu": [
                "latn"
            ]
        },
        "bal-Arab": {
            "nu": [
                "latn"
            ]
        },
        "bal-Latn": {
            "nu": [
                "latn"
            ]
        },
        "bas": {
            "nu": [
                "latn"
            ]
        },
        "be": {
            "nu": [
                "latn"
            ]
        },
        "be-tarask": {
            "nu": [
                "latn"
            ]
        },
        "bem": {
            "nu": [
                "latn"
            ]
        },
        "bew": {
            "nu": [
                "latn"
            ]
        },
        "bez": {
            "nu": [
                "latn"
            ]
        },
        "bg": {
            "nu": [
                "latn"
            ]
        },
        "bgc": {
            "nu": [
                "deva"
            ]
        },
        "bgn": {
            "nu": [
                "arabext"
            ]
        },
        "bgn-AE": {
            "nu": [
                "arabext"
            ]
        },
        "bgn-AF": {
            "nu": [
                "arabext"
            ]
        },
        "bgn-IR": {
            "nu": [
                "arabext"
            ]
        },
        "bgn-OM": {
            "nu": [
                "arabext"
            ]
        },
        "bho": {
            "nu": [
                "deva"
            ]
        },
        "blo": {
            "nu": [
                "latn"
            ]
        },
        "blt": {
            "nu": [
                "latn"
            ]
        },
        "bm": {
            "nu": [
                "latn"
            ]
        },
        "bm-Nkoo": {
            "nu": [
                "latn"
            ]
        },
        "bn": {
            "nu": [
                "beng"
            ]
        },
        "bn-IN": {
            "nu": [
                "beng"
            ]
        },
        "bo": {
            "nu": [
                "latn"
            ]
        },
        "bo-IN": {
            "nu": [
                "latn"
            ]
        },
        "br": {
            "nu": [
                "latn"
            ]
        },
        "brx": {
            "nu": [
                "latn"
            ]
        },
        "bs": {
            "nu": [
                "latn"
            ]
        },
        "bs-Cyrl": {
            "nu": [
                "latn"
            ]
        },
        "bs-Latn": {
            "nu": [
                "latn"
            ]
        },
        "bss": {
            "nu": [
                "latn"
            ]
        },
        "byn": {
            "nu": [
                "latn"
            ]
        },
        "ca": {
            "nu": [
                "latn"
            ]
        },
        "ca-AD": {
            "nu": [
                "latn"
            ]
        },
        "ca-ES-valencia": {
            "nu": [
                "latn"
            ]
        },
        "ca-FR": {
            "nu": [
                "latn"
            ]
        },
        "ca-IT": {
            "nu": [
                "latn"
            ]
        },
        "cad": {
            "nu": [
                "latn"
            ]
        },
        "cch": {
            "nu": [
                "latn"
            ]
        },
        "ccp": {
            "nu": [
                "cakm"
            ]
        },
        "ccp-IN": {
            "nu": [
                "cakm"
            ]
        },
        "ce": {
            "nu": [
                "latn"
            ]
        },
        "ceb": {
            "nu": [
                "latn"
            ]
        },
        "cgg": {
            "nu": [
                "latn"
            ]
        },
        "cho": {
            "nu": [
                "latn"
            ]
        },
        "chr": {
            "nu": [
                "latn"
            ]
        },
        "cic": {
            "nu": [
                "latn"
            ]
        },
        "ckb": {
            "nu": [
                "arab"
            ]
        },
        "ckb-IR": {
            "nu": [
                "arab"
            ]
        },
        "co": {
            "nu": [
                "latn"
            ]
        },
        "cs": {
            "nu": [
                "latn"
            ]
        },
        "csw": {
            "nu": [
                "latn"
            ]
        },
        "cu": {
            "nu": [
                "latn"
            ]
        },
        "cv": {
            "nu": [
                "latn"
            ]
        },
        "cy": {
            "nu": [
                "latn"
            ]
        },
        "da": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "da-GL": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "dav": {
            "nu": [
                "latn"
            ]
        },
        "de": {
            "nu": [
                "latn"
            ]
        },
        "de-AT": {
            "nu": [
                "latn"
            ]
        },
        "de-BE": {
            "nu": [
                "latn"
            ]
        },
        "de-CH": {
            "nu": [
                "latn"
            ]
        },
        "de-IT": {
            "nu": [
                "latn"
            ]
        },
        "de-LI": {
            "nu": [
                "latn"
            ]
        },
        "de-LU": {
            "nu": [
                "latn"
            ]
        },
        "dje": {
            "nu": [
                "latn"
            ]
        },
        "doi": {
            "nu": [
                "latn"
            ]
        },
        "dsb": {
            "nu": [
                "latn"
            ]
        },
        "dua": {
            "nu": [
                "latn"
            ]
        },
        "dv": {
            "nu": [
                "latn"
            ]
        },
        "dyo": {
            "nu": [
                "latn"
            ]
        },
        "dz": {
            "nu": [
                "tibt"
            ]
        },
        "ebu": {
            "nu": [
                "latn"
            ]
        },
        "ee": {
            "nu": [
                "latn"
            ]
        },
        "ee-TG": {
            "nu": [
                "latn"
            ]
        },
        "el": {
            "nu": [
                "latn"
            ]
        },
        "el-CY": {
            "nu": [
                "latn"
            ]
        },
        "el-polyton": {
            "nu": [
                "latn"
            ]
        },
        "en": {
            "nu": [
                "latn"
            ]
        },
        "en-001": {
            "nu": [
                "latn"
            ]
        },
        "en-150": {
            "nu": [
                "latn"
            ]
        },
        "en-AE": {
            "nu": [
                "latn"
            ]
        },
        "en-AG": {
            "nu": [
                "latn"
            ]
        },
        "en-AI": {
            "nu": [
                "latn"
            ]
        },
        "en-AS": {
            "nu": [
                "latn"
            ]
        },
        "en-AT": {
            "nu": [
                "latn"
            ]
        },
        "en-AU": {
            "nu": [
                "latn"
            ]
        },
        "en-BB": {
            "nu": [
                "latn"
            ]
        },
        "en-BE": {
            "nu": [
                "latn"
            ]
        },
        "en-BI": {
            "nu": [
                "latn"
            ]
        },
        "en-BM": {
            "nu": [
                "latn"
            ]
        },
        "en-BS": {
            "nu": [
                "latn"
            ]
        },
        "en-BW": {
            "nu": [
                "latn"
            ]
        },
        "en-BZ": {
            "nu": [
                "latn"
            ]
        },
        "en-CA": {
            "nu": [
                "latn"
            ]
        },
        "en-CC": {
            "nu": [
                "latn"
            ]
        },
        "en-CH": {
            "nu": [
                "latn"
            ]
        },
        "en-CK": {
            "nu": [
                "latn"
            ]
        },
        "en-CM": {
            "nu": [
                "latn"
            ]
        },
        "en-CX": {
            "nu": [
                "latn"
            ]
        },
        "en-CY": {
            "nu": [
                "latn"
            ]
        },
        "en-DE": {
            "nu": [
                "latn"
            ]
        },
        "en-DG": {
            "nu": [
                "latn"
            ]
        },
        "en-DK": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "en-DM": {
            "nu": [
                "latn"
            ]
        },
        "en-Dsrt": {
            "nu": [
                "latn"
            ]
        },
        "en-ER": {
            "nu": [
                "latn"
            ]
        },
        "en-FI": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "en-FJ": {
            "nu": [
                "latn"
            ]
        },
        "en-FK": {
            "nu": [
                "latn"
            ]
        },
        "en-FM": {
            "nu": [
                "latn"
            ]
        },
        "en-GB": {
            "nu": [
                "latn"
            ]
        },
        "en-GD": {
            "nu": [
                "latn"
            ]
        },
        "en-GG": {
            "nu": [
                "latn"
            ]
        },
        "en-GH": {
            "nu": [
                "latn"
            ]
        },
        "en-GI": {
            "nu": [
                "latn"
            ]
        },
        "en-GM": {
            "nu": [
                "latn"
            ]
        },
        "en-GU": {
            "nu": [
                "latn"
            ]
        },
        "en-GY": {
            "nu": [
                "latn"
            ]
        },
        "en-HK": {
            "nu": [
                "latn"
            ]
        },
        "en-ID": {
            "nu": [
                "latn"
            ]
        },
        "en-IE": {
            "nu": [
                "latn"
            ]
        },
        "en-IL": {
            "nu": [
                "latn"
            ]
        },
        "en-IM": {
            "nu": [
                "latn"
            ]
        },
        "en-IN": {
            "nu": [
                "latn"
            ]
        },
        "en-IO": {
            "nu": [
                "latn"
            ]
        },
        "en-JE": {
            "nu": [
                "latn"
            ]
        },
        "en-JM": {
            "nu": [
                "latn"
            ]
        },
        "en-KE": {
            "nu": [
                "latn"
            ]
        },
        "en-KI": {
            "nu": [
                "latn"
            ]
        },
        "en-KN": {
            "nu": [
                "latn"
            ]
        },
        "en-KY": {
            "nu": [
                "latn"
            ]
        },
        "en-LC": {
            "nu": [
                "latn"
            ]
        },
        "en-LR": {
            "nu": [
                "latn"
            ]
        },
        "en-LS": {
            "nu": [
                "latn"
            ]
        },
        "en-MG": {
            "nu": [
                "latn"
            ]
        },
        "en-MH": {
            "nu": [
                "latn"
            ]
        },
        "en-MO": {
            "nu": [
                "latn"
            ]
        },
        "en-MP": {
            "nu": [
                "latn"
            ]
        },
        "en-MS": {
            "nu": [
                "latn"
            ]
        },
        "en-MT": {
            "nu": [
                "latn"
            ]
        },
        "en-MU": {
            "nu": [
                "latn"
            ]
        },
        "en-MV": {
            "nu": [
                "latn"
            ]
        },
        "en-MW": {
            "nu": [
                "latn"
            ]
        },
        "en-MY": {
            "nu": [
                "latn"
            ]
        },
        "en-NA": {
            "nu": [
                "latn"
            ]
        },
        "en-NF": {
            "nu": [
                "latn"
            ]
        },
        "en-NG": {
            "nu": [
                "latn"
            ]
        },
        "en-NL": {
            "nu": [
                "latn"
            ]
        },
        "en-NR": {
            "nu": [
                "latn"
            ]
        },
        "en-NU": {
            "nu": [
                "latn"
            ]
        },
        "en-NZ": {
            "nu": [
                "latn"
            ]
        },
        "en-PG": {
            "nu": [
                "latn"
            ]
        },
        "en-PH": {
            "nu": [
                "latn"
            ]
        },
        "en-PK": {
            "nu": [
                "latn"
            ]
        },
        "en-PN": {
            "nu": [
                "latn"
            ]
        },
        "en-PR": {
            "nu": [
                "latn"
            ]
        },
        "en-PW": {
            "nu": [
                "latn"
            ]
        },
        "en-RW": {
            "nu": [
                "latn"
            ]
        },
        "en-SB": {
            "nu": [
                "latn"
            ]
        },
        "en-SC": {
            "nu": [
                "latn"
            ]
        },
        "en-SD": {
            "nu": [
                "latn"
            ]
        },
        "en-SE": {
            "nu": [
                "latn"
            ]
        },
        "en-SG": {
            "nu": [
                "latn"
            ]
        },
        "en-SH": {
            "nu": [
                "latn"
            ]
        },
        "en-SI": {
            "nu": [
                "latn"
            ]
        },
        "en-SL": {
            "nu": [
                "latn"
            ]
        },
        "en-SS": {
            "nu": [
                "latn"
            ]
        },
        "en-SX": {
            "nu": [
                "latn"
            ]
        },
        "en-SZ": {
            "nu": [
                "latn"
            ]
        },
        "en-Shaw": {
            "nu": [
                "latn"
            ]
        },
        "en-TC": {
            "nu": [
                "latn"
            ]
        },
        "en-TK": {
            "nu": [
                "latn"
            ]
        },
        "en-TO": {
            "nu": [
                "latn"
            ]
        },
        "en-TT": {
            "nu": [
                "latn"
            ]
        },
        "en-TV": {
            "nu": [
                "latn"
            ]
        },
        "en-TZ": {
            "nu": [
                "latn"
            ]
        },
        "en-UG": {
            "nu": [
                "latn"
            ]
        },
        "en-UM": {
            "nu": [
                "latn"
            ]
        },
        "en-VC": {
            "nu": [
                "latn"
            ]
        },
        "en-VG": {
            "nu": [
                "latn"
            ]
        },
        "en-VI": {
            "nu": [
                "latn"
            ]
        },
        "en-VU": {
            "nu": [
                "latn"
            ]
        },
        "en-WS": {
            "nu": [
                "latn"
            ]
        },
        "en-ZA": {
            "nu": [
                "latn"
            ]
        },
        "en-ZM": {
            "nu": [
                "latn"
            ]
        },
        "en-ZW": {
            "nu": [
                "latn"
            ]
        },
        "eo": {
            "nu": [
                "latn"
            ]
        },
        "es": {
            "nu": [
                "latn"
            ]
        },
        "es-419": {
            "nu": [
                "latn"
            ]
        },
        "es-AR": {
            "nu": [
                "latn"
            ]
        },
        "es-BO": {
            "nu": [
                "latn"
            ]
        },
        "es-BR": {
            "nu": [
                "latn"
            ]
        },
        "es-BZ": {
            "nu": [
                "latn"
            ]
        },
        "es-CL": {
            "nu": [
                "latn"
            ]
        },
        "es-CO": {
            "nu": [
                "latn"
            ]
        },
        "es-CR": {
            "nu": [
                "latn"
            ]
        },
        "es-CU": {
            "nu": [
                "latn"
            ]
        },
        "es-DO": {
            "nu": [
                "latn"
            ]
        },
        "es-EA": {
            "nu": [
                "latn"
            ]
        },
        "es-EC": {
            "nu": [
                "latn"
            ]
        },
        "es-GQ": {
            "nu": [
                "latn"
            ]
        },
        "es-GT": {
            "nu": [
                "latn"
            ]
        },
        "es-HN": {
            "nu": [
                "latn"
            ]
        },
        "es-IC": {
            "nu": [
                "latn"
            ]
        },
        "es-MX": {
            "nu": [
                "latn"
            ]
        },
        "es-NI": {
            "nu": [
                "latn"
            ]
        },
        "es-PA": {
            "nu": [
                "latn"
            ]
        },
        "es-PE": {
            "nu": [
                "latn"
            ]
        },
        "es-PH": {
            "nu": [
                "latn"
            ]
        },
        "es-PR": {
            "nu": [
                "latn"
            ]
        },
        "es-PY": {
            "nu": [
                "latn"
            ]
        },
        "es-SV": {
            "nu": [
                "latn"
            ]
        },
        "es-US": {
            "nu": [
                "latn"
            ]
        },
        "es-UY": {
            "nu": [
                "latn"
            ]
        },
        "es-VE": {
            "nu": [
                "latn"
            ]
        },
        "et": {
            "nu": [
                "latn"
            ]
        },
        "eu": {
            "nu": [
                "latn"
            ]
        },
        "ewo": {
            "nu": [
                "latn"
            ]
        },
        "fa": {
            "nu": [
                "arabext"
            ]
        },
        "fa-AF": {
            "nu": [
                "arabext"
            ]
        },
        "ff": {
            "nu": [
                "latn"
            ]
        },
        "ff-Adlm": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-BF": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-CM": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-GH": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-GM": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-GW": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-LR": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-MR": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-NE": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-NG": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-SL": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Adlm-SN": {
            "nu": [
                "adlm"
            ]
        },
        "ff-Latn": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-BF": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-CM": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-GH": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-GM": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-GN": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-GW": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-LR": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-MR": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-NE": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-NG": {
            "nu": [
                "latn"
            ]
        },
        "ff-Latn-SL": {
            "nu": [
                "latn"
            ]
        },
        "fi": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "fil": {
            "nu": [
                "latn"
            ]
        },
        "fo": {
            "nu": [
                "latn"
            ]
        },
        "fo-DK": {
            "nu": [
                "latn"
            ]
        },
        "fr": {
            "nu": [
                "latn"
            ]
        },
        "fr-BE": {
            "nu": [
                "latn"
            ]
        },
        "fr-BF": {
            "nu": [
                "latn"
            ]
        },
        "fr-BI": {
            "nu": [
                "latn"
            ]
        },
        "fr-BJ": {
            "nu": [
                "latn"
            ]
        },
        "fr-BL": {
            "nu": [
                "latn"
            ]
        },
        "fr-CA": {
            "nu": [
                "latn"
            ]
        },
        "fr-CD": {
            "nu": [
                "latn"
            ]
        },
        "fr-CF": {
            "nu": [
                "latn"
            ]
        },
        "fr-CG": {
            "nu": [
                "latn"
            ]
        },
        "fr-CH": {
            "nu": [
                "latn"
            ]
        },
        "fr-CI": {
            "nu": [
                "latn"
            ]
        },
        "fr-CM": {
            "nu": [
                "latn"
            ]
        },
        "fr-DJ": {
            "nu": [
                "latn"
            ]
        },
        "fr-DZ": {
            "nu": [
                "latn"
            ]
        },
        "fr-GA": {
            "nu": [
                "latn"
            ]
        },
        "fr-GF": {
            "nu": [
                "latn"
            ]
        },
        "fr-GN": {
            "nu": [
                "latn"
            ]
        },
        "fr-GP": {
            "nu": [
                "latn"
            ]
        },
        "fr-GQ": {
            "nu": [
                "latn"
            ]
        },
        "fr-HT": {
            "nu": [
                "latn"
            ]
        },
        "fr-KM": {
            "nu": [
                "latn"
            ]
        },
        "fr-LU": {
            "nu": [
                "latn"
            ]
        },
        "fr-MA": {
            "nu": [
                "latn"
            ]
        },
        "fr-MC": {
            "nu": [
                "latn"
            ]
        },
        "fr-MF": {
            "nu": [
                "latn"
            ]
        },
        "fr-MG": {
            "nu": [
                "latn"
            ]
        },
        "fr-ML": {
            "nu": [
                "latn"
            ]
        },
        "fr-MQ": {
            "nu": [
                "latn"
            ]
        },
        "fr-MR": {
            "nu": [
                "latn"
            ]
        },
        "fr-MU": {
            "nu": [
                "latn"
            ]
        },
        "fr-NC": {
            "nu": [
                "latn"
            ]
        },
        "fr-NE": {
            "nu": [
                "latn"
            ]
        },
        "fr-PF": {
            "nu": [
                "latn"
            ]
        },
        "fr-PM": {
            "nu": [
                "latn"
            ]
        },
        "fr-RE": {
            "nu": [
                "latn"
            ]
        },
        "fr-RW": {
            "nu": [
                "latn"
            ]
        },
        "fr-SC": {
            "nu": [
                "latn"
            ]
        },
        "fr-SN": {
            "nu": [
                "latn"
            ]
        },
        "fr-SY": {
            "nu": [
                "latn"
            ]
        },
        "fr-TD": {
            "nu": [
                "latn"
            ]
        },
        "fr-TG": {
            "nu": [
                "latn"
            ]
        },
        "fr-TN": {
            "nu": [
                "latn"
            ]
        },
        "fr-VU": {
            "nu": [
                "latn"
            ]
        },
        "fr-WF": {
            "nu": [
                "latn"
            ]
        },
        "fr-YT": {
            "nu": [
                "latn"
            ]
        },
        "frr": {
            "nu": [
                "latn"
            ]
        },
        "fur": {
            "nu": [
                "latn"
            ]
        },
        "fy": {
            "nu": [
                "latn"
            ]
        },
        "ga": {
            "nu": [
                "latn"
            ]
        },
        "ga-GB": {
            "nu": [
                "latn"
            ]
        },
        "gaa": {
            "nu": [
                "latn"
            ]
        },
        "gd": {
            "nu": [
                "latn"
            ]
        },
        "gez": {
            "nu": [
                "latn"
            ]
        },
        "gez-ER": {
            "nu": [
                "latn"
            ]
        },
        "gl": {
            "nu": [
                "latn"
            ]
        },
        "gn": {
            "nu": [
                "latn"
            ]
        },
        "gsw": {
            "nu": [
                "latn"
            ]
        },
        "gsw-FR": {
            "nu": [
                "latn"
            ]
        },
        "gsw-LI": {
            "nu": [
                "latn"
            ]
        },
        "gu": {
            "nu": [
                "latn"
            ]
        },
        "guz": {
            "nu": [
                "latn"
            ]
        },
        "gv": {
            "nu": [
                "latn"
            ]
        },
        "ha": {
            "nu": [
                "latn"
            ]
        },
        "ha-Arab": {
            "nu": [
                "latn"
            ]
        },
        "ha-Arab-SD": {
            "nu": [
                "latn"
            ]
        },
        "ha-GH": {
            "nu": [
                "latn"
            ]
        },
        "ha-NE": {
            "nu": [
                "latn"
            ]
        },
        "haw": {
            "nu": [
                "latn"
            ]
        },
        "he": {
            "nu": [
                "latn"
            ]
        },
        "hi": {
            "nu": [
                "latn"
            ]
        },
        "hi-Latn": {
            "nu": [
                "latn"
            ]
        },
        "hnj": {
            "nu": [
                "hmnp",
                "latn"
            ]
        },
        "hnj-Hmnp": {
            "nu": [
                "hmnp",
                "latn"
            ]
        },
        "hr": {
            "nu": [
                "latn"
            ]
        },
        "hr-BA": {
            "nu": [
                "latn"
            ]
        },
        "hsb": {
            "nu": [
                "latn"
            ]
        },
        "hu": {
            "nu": [
                "latn"
            ]
        },
        "hy": {
            "nu": [
                "latn"
            ]
        },
        "ia": {
            "nu": [
                "latn"
            ]
        },
        "id": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "ie": {
            "nu": [
                "latn"
            ]
        },
        "ig": {
            "nu": [
                "latn"
            ]
        },
        "ii": {
            "nu": [
                "latn"
            ]
        },
        "io": {
            "nu": [
                "latn"
            ]
        },
        "is": {
            "nu": [
                "latn"
            ]
        },
        "it": {
            "nu": [
                "latn"
            ]
        },
        "it-CH": {
            "nu": [
                "latn"
            ]
        },
        "it-SM": {
            "nu": [
                "latn"
            ]
        },
        "it-VA": {
            "nu": [
                "latn"
            ]
        },
        "iu": {
            "nu": [
                "latn"
            ]
        },
        "iu-Latn": {
            "nu": [
                "latn"
            ]
        },
        "ja": {
            "nu": [
                "latn"
            ]
        },
        "jbo": {
            "nu": [
                "latn"
            ]
        },
        "jgo": {
            "nu": [
                "latn"
            ]
        },
        "jmc": {
            "nu": [
                "latn"
            ]
        },
        "jv": {
            "nu": [
                "latn"
            ]
        },
        "ka": {
            "nu": [
                "latn"
            ]
        },
        "kab": {
            "nu": [
                "latn"
            ]
        },
        "kaj": {
            "nu": [
                "latn"
            ]
        },
        "kam": {
            "nu": [
                "latn"
            ]
        },
        "kcg": {
            "nu": [
                "latn"
            ]
        },
        "kde": {
            "nu": [
                "latn"
            ]
        },
        "kea": {
            "nu": [
                "latn"
            ]
        },
        "ken": {
            "nu": [
                "latn"
            ]
        },
        "kgp": {
            "nu": [
                "latn"
            ]
        },
        "khq": {
            "nu": [
                "latn"
            ]
        },
        "ki": {
            "nu": [
                "latn"
            ]
        },
        "kk": {
            "nu": [
                "latn"
            ]
        },
        "kkj": {
            "nu": [
                "latn"
            ]
        },
        "kl": {
            "nu": [
                "latn"
            ]
        },
        "kln": {
            "nu": [
                "latn"
            ]
        },
        "km": {
            "nu": [
                "latn"
            ]
        },
        "kn": {
            "nu": [
                "latn"
            ]
        },
        "ko": {
            "nu": [
                "latn"
            ]
        },
        "ko-CN": {
            "nu": [
                "latn"
            ]
        },
        "ko-KP": {
            "nu": [
                "latn"
            ]
        },
        "kok": {
            "nu": [
                "latn"
            ]
        },
        "kpe": {
            "nu": [
                "latn"
            ]
        },
        "kpe-GN": {
            "nu": [
                "latn"
            ]
        },
        "ks": {
            "nu": [
                "arabext"
            ]
        },
        "ks-Arab": {
            "nu": [
                "arabext"
            ]
        },
        "ks-Deva": {
            "nu": [
                "latn"
            ]
        },
        "ksb": {
            "nu": [
                "latn"
            ]
        },
        "ksf": {
            "nu": [
                "latn"
            ]
        },
        "ksh": {
            "nu": [
                "latn"
            ]
        },
        "ku": {
            "nu": [
                "latn"
            ]
        },
        "kw": {
            "nu": [
                "latn"
            ]
        },
        "kxv": {
            "nu": [
                "latn"
            ]
        },
        "kxv-Deva": {
            "nu": [
                "latn"
            ]
        },
        "kxv-Latn": {
            "nu": [
                "latn"
            ]
        },
        "kxv-Orya": {
            "nu": [
                "latn"
            ]
        },
        "kxv-Telu": {
            "nu": [
                "latn"
            ]
        },
        "ky": {
            "nu": [
                "latn"
            ]
        },
        "la": {
            "nu": [
                "latn"
            ]
        },
        "lag": {
            "nu": [
                "latn"
            ]
        },
        "lb": {
            "nu": [
                "latn"
            ]
        },
        "lg": {
            "nu": [
                "latn"
            ]
        },
        "lij": {
            "nu": [
                "latn"
            ]
        },
        "lkt": {
            "nu": [
                "latn"
            ]
        },
        "lmo": {
            "nu": [
                "latn"
            ]
        },
        "ln": {
            "nu": [
                "latn"
            ]
        },
        "ln-AO": {
            "nu": [
                "latn"
            ]
        },
        "ln-CF": {
            "nu": [
                "latn"
            ]
        },
        "ln-CG": {
            "nu": [
                "latn"
            ]
        },
        "lo": {
            "nu": [
                "latn"
            ]
        },
        "lrc": {
            "nu": [
                "arabext"
            ]
        },
        "lrc-IQ": {
            "nu": [
                "arabext"
            ]
        },
        "lt": {
            "nu": [
                "latn"
            ]
        },
        "lu": {
            "nu": [
                "latn"
            ]
        },
        "luo": {
            "nu": [
                "latn"
            ]
        },
        "luy": {
            "nu": [
                "latn"
            ]
        },
        "lv": {
            "nu": [
                "latn"
            ]
        },
        "mai": {
            "nu": [
                "latn"
            ]
        },
        "mas": {
            "nu": [
                "latn"
            ]
        },
        "mas-TZ": {
            "nu": [
                "latn"
            ]
        },
        "mdf": {
            "nu": [
                "latn"
            ]
        },
        "mer": {
            "nu": [
                "latn"
            ]
        },
        "mfe": {
            "nu": [
                "latn"
            ]
        },
        "mg": {
            "nu": [
                "latn"
            ]
        },
        "mgh": {
            "nu": [
                "latn"
            ]
        },
        "mgo": {
            "nu": [
                "latn"
            ]
        },
        "mi": {
            "nu": [
                "latn"
            ]
        },
        "mic": {
            "nu": [
                "latn"
            ]
        },
        "mk": {
            "nu": [
                "latn"
            ]
        },
        "ml": {
            "nu": [
                "latn"
            ]
        },
        "mn": {
            "nu": [
                "latn"
            ]
        },
        "mn-Mong": {
            "nu": [
                "latn"
            ]
        },
        "mn-Mong-MN": {
            "nu": [
                "latn"
            ]
        },
        "mni": {
            "nu": [
                "beng"
            ]
        },
        "mni-Beng": {
            "nu": [
                "beng"
            ]
        },
        "mni-Mtei": {
            "nu": [
                "mtei"
            ]
        },
        "moh": {
            "nu": [
                "latn"
            ]
        },
        "mr": {
            "nu": [
                "deva"
            ]
        },
        "ms": {
            "nu": [
                "latn"
            ]
        },
        "ms-Arab": {
            "nu": [
                "latn"
            ]
        },
        "ms-Arab-BN": {
            "nu": [
                "latn"
            ]
        },
        "ms-BN": {
            "nu": [
                "latn"
            ]
        },
        "ms-ID": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "ms-SG": {
            "nu": [
                "latn"
            ]
        },
        "mt": {
            "nu": [
                "latn"
            ]
        },
        "mua": {
            "nu": [
                "latn"
            ]
        },
        "mus": {
            "nu": [
                "latn"
            ]
        },
        "my": {
            "nu": [
                "mymr"
            ]
        },
        "myv": {
            "nu": [
                "latn"
            ]
        },
        "mzn": {
            "nu": [
                "arabext"
            ]
        },
        "naq": {
            "nu": [
                "latn"
            ]
        },
        "nb": {
            "nu": [
                "latn"
            ]
        },
        "nb-SJ": {
            "nu": [
                "latn"
            ]
        },
        "nd": {
            "nu": [
                "latn"
            ]
        },
        "nds": {
            "nu": [
                "latn"
            ]
        },
        "nds-NL": {
            "nu": [
                "latn"
            ]
        },
        "ne": {
            "nu": [
                "deva"
            ]
        },
        "ne-IN": {
            "nu": [
                "deva"
            ]
        },
        "nl": {
            "nu": [
                "latn"
            ]
        },
        "nl-AW": {
            "nu": [
                "latn"
            ]
        },
        "nl-BE": {
            "nu": [
                "latn"
            ]
        },
        "nl-BQ": {
            "nu": [
                "latn"
            ]
        },
        "nl-CW": {
            "nu": [
                "latn"
            ]
        },
        "nl-SR": {
            "nu": [
                "latn"
            ]
        },
        "nl-SX": {
            "nu": [
                "latn"
            ]
        },
        "nmg": {
            "nu": [
                "latn"
            ]
        },
        "nn": {
            "nu": [
                "latn"
            ]
        },
        "nnh": {
            "nu": [
                "latn"
            ]
        },
        "no": {
            "nu": [
                "latn"
            ]
        },
        "nqo": {
            "nu": [
                "nkoo"
            ]
        },
        "nr": {
            "nu": [
                "latn"
            ]
        },
        "nso": {
            "nu": [
                "latn"
            ]
        },
        "nus": {
            "nu": [
                "latn"
            ]
        },
        "nv": {
            "nu": [
                "latn"
            ]
        },
        "ny": {
            "nu": [
                "latn"
            ]
        },
        "nyn": {
            "nu": [
                "latn"
            ]
        },
        "oc": {
            "nu": [
                "latn"
            ]
        },
        "oc-ES": {
            "nu": [
                "latn"
            ]
        },
        "om": {
            "nu": [
                "latn"
            ]
        },
        "om-KE": {
            "nu": [
                "latn"
            ]
        },
        "or": {
            "nu": [
                "latn"
            ]
        },
        "os": {
            "nu": [
                "latn"
            ]
        },
        "os-RU": {
            "nu": [
                "latn"
            ]
        },
        "osa": {
            "nu": [
                "latn"
            ]
        },
        "pa": {
            "nu": [
                "latn"
            ]
        },
        "pa-Arab": {
            "nu": [
                "arabext"
            ]
        },
        "pa-Guru": {
            "nu": [
                "latn"
            ]
        },
        "pap": {
            "nu": [
                "latn"
            ]
        },
        "pap-AW": {
            "nu": [
                "latn"
            ]
        },
        "pcm": {
            "nu": [
                "latn"
            ]
        },
        "pis": {
            "nu": [
                "latn"
            ]
        },
        "pl": {
            "nu": [
                "latn"
            ]
        },
        "prg": {
            "nu": [
                "latn"
            ]
        },
        "ps": {
            "nu": [
                "arabext"
            ]
        },
        "ps-PK": {
            "nu": [
                "arabext"
            ]
        },
        "pt": {
            "nu": [
                "latn"
            ]
        },
        "pt-AO": {
            "nu": [
                "latn"
            ]
        },
        "pt-CH": {
            "nu": [
                "latn"
            ]
        },
        "pt-CV": {
            "nu": [
                "latn"
            ]
        },
        "pt-GQ": {
            "nu": [
                "latn"
            ]
        },
        "pt-GW": {
            "nu": [
                "latn"
            ]
        },
        "pt-LU": {
            "nu": [
                "latn"
            ]
        },
        "pt-MO": {
            "nu": [
                "latn"
            ]
        },
        "pt-MZ": {
            "nu": [
                "latn"
            ]
        },
        "pt-PT": {
            "nu": [
                "latn"
            ]
        },
        "pt-ST": {
            "nu": [
                "latn"
            ]
        },
        "pt-TL": {
            "nu": [
                "latn"
            ]
        },
        "qu": {
            "nu": [
                "latn"
            ]
        },
        "qu-BO": {
            "nu": [
                "latn"
            ]
        },
        "qu-EC": {
            "nu": [
                "latn"
            ]
        },
        "quc": {
            "nu": [
                "latn"
            ]
        },
        "raj": {
            "nu": [
                "deva"
            ]
        },
        "rhg": {
            "nu": [
                "latn"
            ]
        },
        "rhg-Rohg": {
            "nu": [
                "latn"
            ]
        },
        "rhg-Rohg-BD": {
            "nu": [
                "latn"
            ]
        },
        "rif": {
            "nu": [
                "latn"
            ]
        },
        "rm": {
            "nu": [
                "latn"
            ]
        },
        "rn": {
            "nu": [
                "latn"
            ]
        },
        "ro": {
            "nu": [
                "latn"
            ]
        },
        "ro-MD": {
            "nu": [
                "latn"
            ]
        },
        "rof": {
            "nu": [
                "latn"
            ]
        },
        "ru": {
            "nu": [
                "latn"
            ]
        },
        "ru-BY": {
            "nu": [
                "latn"
            ]
        },
        "ru-KG": {
            "nu": [
                "latn"
            ]
        },
        "ru-KZ": {
            "nu": [
                "latn"
            ]
        },
        "ru-MD": {
            "nu": [
                "latn"
            ]
        },
        "ru-UA": {
            "nu": [
                "latn"
            ]
        },
        "rw": {
            "nu": [
                "latn"
            ]
        },
        "rwk": {
            "nu": [
                "latn"
            ]
        },
        "sa": {
            "nu": [
                "deva"
            ]
        },
        "sah": {
            "nu": [
                "latn"
            ]
        },
        "saq": {
            "nu": [
                "latn"
            ]
        },
        "sat": {
            "nu": [
                "olck"
            ]
        },
        "sat-Deva": {
            "nu": [
                "deva"
            ]
        },
        "sat-Olck": {
            "nu": [
                "olck"
            ]
        },
        "sbp": {
            "nu": [
                "latn"
            ]
        },
        "sc": {
            "nu": [
                "latn"
            ]
        },
        "scn": {
            "nu": [
                "latn"
            ]
        },
        "sd": {
            "nu": [
                "arab"
            ]
        },
        "sd-Arab": {
            "nu": [
                "arab"
            ]
        },
        "sd-Deva": {
            "nu": [
                "latn"
            ]
        },
        "sdh": {
            "nu": [
                "arab"
            ]
        },
        "sdh-IQ": {
            "nu": [
                "arab"
            ]
        },
        "se": {
            "nu": [
                "latn"
            ]
        },
        "se-FI": {
            "nu": [
                "latn"
            ]
        },
        "se-SE": {
            "nu": [
                "latn"
            ]
        },
        "seh": {
            "nu": [
                "latn"
            ]
        },
        "ses": {
            "nu": [
                "latn"
            ]
        },
        "sg": {
            "nu": [
                "latn"
            ]
        },
        "shi": {
            "nu": [
                "latn"
            ]
        },
        "shi-Latn": {
            "nu": [
                "latn"
            ]
        },
        "shi-Tfng": {
            "nu": [
                "latn"
            ]
        },
        "shn": {
            "nu": [
                "latn"
            ]
        },
        "shn-TH": {
            "nu": [
                "latn"
            ]
        },
        "si": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "sid": {
            "nu": [
                "latn"
            ]
        },
        "sk": {
            "nu": [
                "latn"
            ]
        },
        "skr": {
            "nu": [
                "latn"
            ]
        },
        "sl": {
            "nu": [
                "latn"
            ]
        },
        "sma": {
            "nu": [
                "latn"
            ]
        },
        "sma-NO": {
            "nu": [
                "latn"
            ]
        },
        "smj": {
            "nu": [
                "latn"
            ]
        },
        "smj-NO": {
            "nu": [
                "latn"
            ]
        },
        "smn": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "sms": {
            "nu": [
                "latn"
            ]
        },
        "sn": {
            "nu": [
                "latn"
            ]
        },
        "so": {
            "nu": [
                "latn"
            ]
        },
        "so-DJ": {
            "nu": [
                "latn"
            ]
        },
        "so-ET": {
            "nu": [
                "latn"
            ]
        },
        "so-KE": {
            "nu": [
                "latn"
            ]
        },
        "sq": {
            "nu": [
                "latn"
            ]
        },
        "sq-MK": {
            "nu": [
                "latn"
            ]
        },
        "sq-XK": {
            "nu": [
                "latn"
            ]
        },
        "sr": {
            "nu": [
                "latn"
            ]
        },
        "sr-Cyrl": {
            "nu": [
                "latn"
            ]
        },
        "sr-Cyrl-BA": {
            "nu": [
                "latn"
            ]
        },
        "sr-Cyrl-ME": {
            "nu": [
                "latn"
            ]
        },
        "sr-Cyrl-XK": {
            "nu": [
                "latn"
            ]
        },
        "sr-Latn": {
            "nu": [
                "latn"
            ]
        },
        "sr-Latn-BA": {
            "nu": [
                "latn"
            ]
        },
        "sr-Latn-ME": {
            "nu": [
                "latn"
            ]
        },
        "sr-Latn-XK": {
            "nu": [
                "latn"
            ]
        },
        "ss": {
            "nu": [
                "latn"
            ]
        },
        "ss-SZ": {
            "nu": [
                "latn"
            ]
        },
        "ssy": {
            "nu": [
                "latn"
            ]
        },
        "st": {
            "nu": [
                "latn"
            ]
        },
        "st-LS": {
            "nu": [
                "latn"
            ]
        },
        "su": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "su-Latn": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "sv": {
            "nu": [
                "latn"
            ]
        },
        "sv-AX": {
            "nu": [
                "latn"
            ]
        },
        "sv-FI": {
            "nu": [
                "latn"
            ],
            "separator": {
                "latn": "."
            }
        },
        "sw": {
            "nu": [
                "latn"
            ]
        },
        "sw-CD": {
            "nu": [
                "latn"
            ]
        },
        "sw-KE": {
            "nu": [
                "latn"
            ]
        },
        "sw-UG": {
            "nu": [
                "latn"
            ]
        },
        "syr": {
            "nu": [
                "latn"
            ]
        },
        "syr-SY": {
            "nu": [
                "latn"
            ]
        },
        "szl": {
            "nu": [
                "latn"
            ]
        },
        "ta": {
            "nu": [
                "latn"
            ]
        },
        "ta-LK": {
            "nu": [
                "latn"
            ]
        },
        "ta-MY": {
            "nu": [
                "latn"
            ]
        },
        "ta-SG": {
            "nu": [
                "latn"
            ]
        },
        "te": {
            "nu": [
                "latn"
            ]
        },
        "teo": {
            "nu": [
                "latn"
            ]
        },
        "teo-KE": {
            "nu": [
                "latn"
            ]
        },
        "tg": {
            "nu": [
                "latn"
            ]
        },
        "th": {
            "nu": [
                "latn"
            ]
        },
        "ti": {
            "nu": [
                "latn"
            ]
        },
        "ti-ER": {
            "nu": [
                "latn"
            ]
        },
        "tig": {
            "nu": [
                "latn"
            ]
        },
        "tk": {
            "nu": [
                "latn"
            ]
        },
        "tn": {
            "nu": [
                "latn"
            ]
        },
        "tn-BW": {
            "nu": [
                "latn"
            ]
        },
        "to": {
            "nu": [
                "latn"
            ]
        },
        "tok": {
            "nu": [
                "latn"
            ]
        },
        "tpi": {
            "nu": [
                "latn"
            ]
        },
        "tr": {
            "nu": [
                "latn"
            ]
        },
        "tr-CY": {
            "nu": [
                "latn"
            ]
        },
        "trv": {
            "nu": [
                "latn"
            ]
        },
        "trw": {
            "nu": [
                "latn"
            ]
        },
        "ts": {
            "nu": [
                "latn"
            ]
        },
        "tt": {
            "nu": [
                "latn"
            ]
        },
        "twq": {
            "nu": [
                "latn"
            ]
        },
        "tyv": {
            "nu": [
                "latn"
            ]
        },
        "tzm": {
            "nu": [
                "latn"
            ]
        },
        "ug": {
            "nu": [
                "latn"
            ]
        },
        "uk": {
            "nu": [
                "latn"
            ]
        },
        "und": {
            "nu": [
                "latn"
            ]
        },
        "ur": {
            "nu": [
                "latn"
            ]
        },
        "ur-IN": {
            "nu": [
                "arabext"
            ],
            "separator": {
                "arabext": "٫"
            }
        },
        "uz": {
            "nu": [
                "latn"
            ]
        },
        "uz-Arab": {
            "nu": [
                "arabext"
            ]
        },
        "uz-Cyrl": {
            "nu": [
                "latn"
            ]
        },
        "uz-Latn": {
            "nu": [
                "latn"
            ]
        },
        "vai": {
            "nu": [
                "latn"
            ]
        },
        "vai-Latn": {
            "nu": [
                "latn"
            ]
        },
        "vai-Vaii": {
            "nu": [
                "latn"
            ]
        },
        "ve": {
            "nu": [
                "latn"
            ]
        },
        "vec": {
            "nu": [
                "latn"
            ]
        },
        "vi": {
            "nu": [
                "latn"
            ]
        },
        "vmw": {
            "nu": [
                "latn"
            ]
        },
        "vo": {
            "nu": [
                "latn"
            ]
        },
        "vun": {
            "nu": [
                "latn"
            ]
        },
        "wa": {
            "nu": [
                "latn"
            ]
        },
        "wae": {
            "nu": [
                "latn"
            ]
        },
        "wal": {
            "nu": [
                "latn"
            ]
        },
        "wbp": {
            "nu": [
                "latn"
            ]
        },
        "wo": {
            "nu": [
                "latn"
            ]
        },
        "xh": {
            "nu": [
                "latn"
            ]
        },
        "xnr": {
            "nu": [
                "latn"
            ]
        },
        "xog": {
            "nu": [
                "latn"
            ]
        },
        "yav": {
            "nu": [
                "latn"
            ]
        },
        "yi": {
            "nu": [
                "latn"
            ]
        },
        "yo": {
            "nu": [
                "latn"
            ]
        },
        "yo-BJ": {
            "nu": [
                "latn"
            ]
        },
        "yrl": {
            "nu": [
                "latn"
            ]
        },
        "yrl-CO": {
            "nu": [
                "latn"
            ]
        },
        "yrl-VE": {
            "nu": [
                "latn"
            ]
        },
        "yue": {
            "nu": [
                "latn"
            ]
        },
        "yue-Hans": {
            "nu": [
                "latn"
            ]
        },
        "yue-Hant": {
            "nu": [
                "latn"
            ]
        },
        "za": {
            "nu": [
                "latn"
            ]
        },
        "zgh": {
            "nu": [
                "latn"
            ]
        },
        "zh": {
            "nu": [
                "latn"
            ]
        },
        "zh-Hans": {
            "nu": [
                "latn"
            ]
        },
        "zh-Hans-HK": {
            "nu": [
                "latn"
            ]
        },
        "zh-Hans-MO": {
            "nu": [
                "latn"
            ]
        },
        "zh-Hans-SG": {
            "nu": [
                "latn"
            ]
        },
        "zh-Hant": {
            "nu": [
                "latn"
            ]
        },
        "zh-Hant-HK": {
            "nu": [
                "latn"
            ]
        },
        "zh-Hant-MO": {
            "nu": [
                "latn"
            ]
        },
        "zu": {
            "nu": [
                "latn"
            ]
        }
    }
};
